export type ShippingMethodRule = {
  id?: number;
  shippingMethodId?: number;
  expression: string;
  quantity: number | string;
  price: number | string;
};

export const matchesShippingRule = (
  orderQty: number,
  expression: string,
  ruleQty: number
): boolean => {
  switch ((expression || "").trim()) {
    case ">=":
      return orderQty >= ruleQty;
    case ">":
      return orderQty > ruleQty;
    case "<=":
      return orderQty <= ruleQty;
    case "<":
      return orderQty < ruleQty;
    case "=":
    case "==":
      return orderQty === ruleQty;
    default:
      return false;
  }
};

/** Sum of orderQuantityRequested across supply order items */
export const getTotalOrderQuantity = (items: any[] = []): number => {
  return (Array.isArray(items) ? items : []).reduce((sum, item) => {
    const qty = Number(item?.orderQuantityRequested);
    return sum + (Number.isNaN(qty) ? 0 : qty);
  }, 0);
};

/** Sum of totalPrice across supply order items */
export const getTotalItemsPrice = (items: any[] = []): number => {
  return (Array.isArray(items) ? items : []).reduce((sum, item) => {
    const price = Number(item?.totalPrice);
    return sum + (Number.isNaN(price) ? 0 : price);
  }, 0);
};

export const formatMoney = (
  value: number | string | null | undefined
): string => {
  const num = Number(value);
  if (
    value === "" ||
    value === null ||
    value === undefined ||
    Number.isNaN(num)
  ) {
    return "0.00";
  }
  return num.toFixed(2);
};

/**
 * Picks the best matching rule for the given quantity.
 * Among matches, prefers the rule with the highest quantity threshold.
 */
export const calculateShippingPriceFromRules = (
  rules: ShippingMethodRule[] = [],
  orderQty: number
): number | null => {
  if (!rules?.length || Number.isNaN(orderQty)) return null;

  const matching = rules.filter((rule) =>
    matchesShippingRule(orderQty, rule.expression, Number(rule.quantity))
  );

  if (!matching.length) return null;

  matching.sort((a, b) => Number(b.quantity) - Number(a.quantity));
  const price = Number(matching[0].price);
  return Number.isNaN(price) ? null : price;
};
